import React from "react";

const AboutHero = () => {
  return (
    <div className="flex h-[100vh] text-white flex-col gap-10 items-center justify-center bg-gradient-to-r from-blue-900 to-orange-500 lg:py-40 py-16 px-12 mb-5">
      <h1 className="text-4xl md:text-5xl font-bold leading-tight mb-4">
        About ProbiMining
      </h1>
      <h3 className="text-lg md:text-xl mb-8 lg:mx-auto lg:w-[70%] lg:text-center text-left w-full mx-2">
        At Probi Mining, we believe in unlocking the true potential of
        cryptocurrency investment. With a commitment to transparency, security,
        and cutting-edge technology, we provide you with the tools and insights
        needed to navigate the digital financial revolution. Our mission is
        simple: to help you make informed, confident decisions in a
        fast-evolving market. Join us as we lead the way to a more prosperous,
        decentralized future.
      </h3>
      <div className="flex gap-4">
        {/* Primary CTA */}
        <a
          href="/login"
          className="bg-secondary-500 text-black py-3 px-8 rounded-lg text-xl font-semibold transition-all hover:bg-secondary-600 hover:scale-105"
        >
          Join Us
        </a>
      </div>
    </div>
  );
};

export default AboutHero;
